/**
 * A nota do perito que a seção ainda não tem (E202.F2, GUS-145, ADR-0145 §7): no fim de cada seção
 * que aceita nota, um convite discreto, "Escrever uma nota nesta seção", que abre o editor ali. A nota
 * escrita aparece no papel como as outras partes (`ParteDoDocumento`), com o rótulo do modo.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { SecaoDoDocumentoData } from '@/lib/documentoDaSaida';

import { PALETA } from './paleta';
import { ParteEmEdicao } from './ParteEmEdicao';
import type { ContextoDasPartes } from './ParteDoDocumento';

const t = ptBR.documentoDaMesa.edicao;

export function NotasNovas({
  secao,
  contexto,
}: {
  secao: SecaoDoDocumentoData;
  contexto: ContextoDasPartes;
}): JSX.Element | null {
  const { edicao } = contexto;
  if (edicao === null || secao.chave === null) return null;
  const nasPartes = new Set(secao.blocos.flatMap((b) => b.partes.map((p) => p.trecho_id)));
  const notas = [...contexto.trechos.values()].filter(
    (x) => x.tipo === 'nota' && x.secao === secao.chave && !nasPartes.has(x.id),
  );
  return (
    <>
      {notas.map((nota) =>
        edicao.aberto === nota.id ? (
          <ParteEmEdicao
            key={nota.id}
            trecho={nota}
            paragrafos={[]}
            modo="rico"
            rascunho={edicao.rascunhos.get(nota.id)}
            edicao={edicao}
          />
        ) : (
          <button
            key={nota.id}
            type="button"
            className="my-1 block text-left text-[0.85em] underline-offset-2 opacity-70 hover:underline hover:opacity-100"
            style={{ color: PALETA.navy2 }}
            onClick={() => edicao.abrir(nota.id)}
            data-trecho={nota.id}
            data-testid="documento-nota-nova"
          >
            {edicao.rascunhos.has(nota.id) ? `${t.notaNova} · ${t.rascunho}` : t.notaNova}
          </button>
        ),
      )}
    </>
  );
}
